import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import {
  SignOutButton
} from 'components/Authentication';

const styles = {
  root: {
    flexGrow: 1,
  },
  flex: {
    flex: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
};

class MainNavigation extends React.Component {
  state = {
    anchorEl: null,
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const {
      classes
    } = this.props;

    return (
      <AppBar position="static">
        <Toolbar>
          <Typography variant="title" color="inherit" className={classes.flex}>
            {process.env.REACT_APP_SITE_TITLE}
          </Typography>
          <SignOutButton />
        </Toolbar>
      </AppBar>
    );
  }
}

MainNavigation.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MainNavigation);


// WEBPACK FOOTER //
// ./src/components/Layout/MainNavigation.js